import { render, staticRenderFns } from "./EndpointManager.vue?vue&type=template&id=4825407a&scoped=true&"
import script from "./EndpointManager.vue?vue&type=script&lang=js&"
export * from "./EndpointManager.vue?vue&type=script&lang=js&"
import style0 from "./EndpointManager.vue?vue&type=style&index=0&id=4825407a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825407a",
  null
  
)

export default component.exports